module.exports = __webpack_public_path__ + "static/img/Instagram.a50aec20.png";